import { render, staticRenderFns } from "./StarArticleWrap.vue?vue&type=template&id=04a5f4fe"
import script from "./StarArticleWrap.vue?vue&type=script&lang=js"
export * from "./StarArticleWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports